const t = "_root_3z37t_1", o = "_actionCellRoot_3z37t_1", c = "_compact_3z37t_10", _ = "_standard_3z37t_13", a = "_comfort_3z37t_16", n = {
  root: t,
  actionCellRoot: o,
  compact: c,
  standard: _,
  comfort: a
};
export {
  o as actionCellRoot,
  a as comfort,
  c as compact,
  n as default,
  t as root,
  _ as standard
};
//# sourceMappingURL=index.es5640.js.map
